import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'
import id from './../../locales/id.json'

i18n
  .init({
    fallbackLng: 'id',
    lng: 'id',
    react: {
      wait: false,
    },
    resources: {
      id: {
        translation: {
          ...id,
        }
      }
    },
    react: {
      wait: true
    }
  })

export default i18n;


// WEBPACK FOOTER //
// ./assets/js/locale.js